import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PopupItemDirective } from '@widgets/popup/popup-item.directive';
import { PopupTriggerDirective } from '@widgets/popup/popup-trigger.directive';
import { PopupComponent } from '@widgets/popup/popup/popup.component';

@NgModule({
  imports: [CommonModule],
  declarations: [PopupComponent, PopupTriggerDirective, PopupItemDirective],
  exports: [PopupComponent, PopupTriggerDirective, PopupItemDirective],
})
export class PopupModule {}
